// Auteur-registry voor de kennisbank.
// Per auteur: slug (auteurspagina /kennisbank/auteur/<slug>), weergavenaam,
// functie, rol, profielfoto, korte bio en LinkedIn.
// BlogArtikel.js resolt de auteur via getAuthor(article.author).
// Functie en LinkedIn zoals op Over ons (src/pages/OverOns.js). Zonder foto toont
// de kennisbank de initialen.

const authors = {
  'Yasar Kocdas': {
    slug: 'yasar-kocdas',
    name: 'Yasar Kocdas',
    functie: 'Oprichter & CEO',
    role: 'Oprichter & CEO TestWisely',
    photo: '/team/yasar.jpg',
    bio: 'Oprichter van TestWisely en oud-docent. Bouwt aan een platform dat docenten meer tijd geeft voor wat echt belangrijk is: lesgeven.',
    linkedin: 'https://www.linkedin.com/in/yasar-kocdas/',
  },
  'Mohamed Bentaher': {
    slug: 'mohamed-bentaher',
    name: 'Mohamed Bentaher',
    functie: 'Lead Developer',
    role: 'Lead Developer TestWisely',
    photo: '/team/mohammed.jpg',
    bio: 'Lead Developer bij TestWisely. Bouwt aan het platform zelf: de toetsomgeving, het nakijken en alles wat docenten en leerlingen ermee doen.',
    linkedin: 'https://www.linkedin.com/in/mohamed-bentaher/',
  },
  'Ismail Marghich': {
    slug: 'ismail-marghich',
    name: 'Ismail Marghich',
    functie: 'Quality Assurance Engineer',
    role: 'Quality Assurance Engineer TestWisely',
    photo: null,
    initials: 'IM',
    bio: 'Quality Assurance Engineer bij TestWisely. Test elke nieuwe functie voordat die bij scholen komt, van beveiligd toetsen tot toegankelijkheid.',
    linkedin: 'https://www.linkedin.com/in/ismail-marghich-9174111aa/',
  },
  'Ilias Amejar': {
    slug: 'ilias-amejar',
    name: 'Ilias Amejar',
    functie: 'Legal Counsel',
    role: 'Legal Counsel TestWisely',
    photo: '/team/ilias.jpg',
    bio: 'Legal Counsel bij TestWisely. Houdt zich bezig met privacy, AVG en de juridische kant van digitaal toetsen in het onderwijs.',
    linkedin: 'https://www.linkedin.com/in/ilias-a-b63a57201/',
  },
};

// Geen slug: de redactie heeft geen eigen auteurspagina.
const FALLBACK = {
  name: 'TestWisely',
  role: 'TestWisely-redactie',
  photo: '/team/yasar.jpg',
  bio: 'Geschreven door het TestWisely-team.',
};

// Resolveert een auteur op naam. Normaliseert varianten zoals
// 'Yasar Kocdas, oprichter TestWisely' naar de geregistreerde auteur.
export function getAuthor(name) {
  if (!name) return FALLBACK;
  const key = name.split(',')[0].trim();
  return authors[key] || { ...FALLBACK, name: key };
}

// "mohamed-bentaher" → de auteur, of null bij een onbekende slug.
export function auteurMetSlug(slug) {
  return Object.values(authors).find((a) => a.slug === slug) || null;
}

// Pad naar de auteurspagina, of null voor een auteur zonder pagina.
export function auteurPad(author) {
  return author?.slug ? `/kennisbank/auteur/${author.slug}` : null;
}

// "Ismail Marghich" → "IM"; voor auteurs zonder foto.
export function initialenVan(author) {
  if (author?.initials) return author.initials;
  return (author?.name || '')
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase())
    .slice(0, 2)
    .join('');
}

export default authors;
